import { Component, OnInit, OnDestroy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { SharedService } from '../../shared.service';
import { ToastrService } from 'ngx-toastr';
import Swal from 'sweetalert2';
@Component({
    selector: 'app-registration-status',
    templateUrl: '../pages/registration_status.component.html',
    styleUrls: ['../css/image_view.css']
})

export class RegistrationStatusComponent implements OnInit, OnDestroy {

    public statusForm: UntypedFormGroup = this.fb.group({
        registerId: ['']
    })
    get status() {
        return this.statusForm.controls;
      }
    constructor(
        private fb: UntypedFormBuilder,
        public translate: TranslateService,
        private router: Router,
        private shareService: SharedService,
        private toastr: ToastrService,
    ) { }

    onSubmit() {
        this.shareService.getStatusData(this.statusForm.get('registerId').value).subscribe((data) => {
            Swal.fire({
                icon: 'info',
                title: 'Your application status!',
                text: this.translate.instant(data['message']),
                confirmButtonText: 'Okay'
            })
        })
     }

    ngOnInit() {
        
    }

    ngOnDestroy(): void { }

}
